import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7925ffe9"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "under-construction"
};
const _hoisted_2 = {
  class: "app-container"
};
const _hoisted_3 = {
  style: {
    "margin-top": "32px",
    "margin-bottom": "18px"
  }
};
const _hoisted_4 = {
  class: "category-bar new-category-bar"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
  key: 0,
  class: "category-icon new-category-icon"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont iconfont-home",
  style: {
    "font-size": "20px",
    "margin-right": "6px"
  }
}, null, -1));
const _hoisted_8 = [_hoisted_7];
const _hoisted_9 = {
  class: "main__layout"
};
const _hoisted_10 = {
  class: "recommended-container"
};
const _hoisted_11 = {
  class: "container new-video-container"
};
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<div class=\"video-card__skeleton hide\" data-v-7925ffe9><div class=\"video-card__skeleton--cover\" data-v-7925ffe9></div><div class=\"video-card__skeleton--info\" data-v-7925ffe9><div class=\"video-card__skeleton--right\" data-v-7925ffe9><p class=\"video-card__skeleton--text\" data-v-7925ffe9></p><p class=\"video-card__skeleton--text short\" data-v-7925ffe9></p><p class=\"video-card__skeleton--light\" data-v-7925ffe9></p></div></div></div>", 1);
const _hoisted_13 = ["href"];
const _hoisted_14 = {
  class: "video-card__wrap new-video-card__wrap"
};
const _hoisted_15 = {
  class: "video-card__image new-video-card__image"
};
const _hoisted_16 = {
  class: "video-card__image--wrap new-video-card__image--wrap"
};
const _hoisted_17 = {
  class: "video-card__cover new-video-card__cover"
};
const _hoisted_18 = ["src", "alt"];
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "video-card__mask new-video-card__mask"
}, null, -1));
const _hoisted_20 = {
  class: "video-card__mask new-video-card__mask"
};
const _hoisted_21 = {
  class: "video-card__stats new-video-card__stats"
};
const _hoisted_22 = {
  class: "video-card__stats--left new-video-card__stats--left"
};
const _hoisted_23 = {
  class: "video-card__stats--item new-video-card__stats--item"
};
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-bofangshu"
}, null, -1));
const _hoisted_25 = {
  class: "video-card__stats--text new-video-card__stats--text"
};
const _hoisted_26 = {
  class: "video-card__stats--item new-video-card__stats--item"
};
const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-danmushu"
}, null, -1));
const _hoisted_28 = {
  class: "video-card__stats--text new-video-card__stats--text"
};
const _hoisted_29 = {
  class: "video-card__stats__duration new-video-card__stats__duration"
};
const _hoisted_30 = {
  class: "video-card__info new-video-card__info"
};
const _hoisted_31 = {
  class: "video-card__info--right new-video-card__info--right"
};
const _hoisted_32 = {
  class: "video-card__info--tit new-video-card__info--tit"
};
const _hoisted_33 = ["href", "title"];
import { onMounted, ref } from "vue";
import "../styles/videoCard.css";
import { SysDictDataControllerService } from "../../generated";
import { XiaoniuFrontedControllerService } from "../../generated/services/XiaoniuFrontedControllerService";
export default /*#__PURE__*/_defineComponent({
  __name: 'VideoView',
  setup(__props) {
    const categoryNameList = ref([]);
    // const cumulativeVideos = ref([{
    //       "vid": 1,
    //       "title": "cs",
    //       "type": 1,
    //       "duration": 71.4,
    //       "descr": "124",
    //       "coverUrl": "https://xiaoniu-test.oss-cn-hangzhou.aliyuncs.com/20240814/img/cover/1723618796290792efbc415b24b5bb0351c82d9caf60f.jpg",
    //       "videoUrl": "https://xiaoniu-test.oss-cn-hangzhou.aliyuncs.com/20240814/video/1723618796791e5823810b1c8400c90daeb276d14d7df.mp4",
    //       "status": 1,
    //       "uploadDate": "2024-08-14 15:07",
    //       "deleteDate": null,
    //       "play": 12345,
    //       "danmu": 123,
    //     },
    //     ]
    // );
    // 定义响应式的选中的类别
    const selectedCategory = ref("0");
    //切换视频分类
    const changeCategory = type => {
      selectedCategory.value = type;
      if (type === '0') {
        queryParams.value.type = null;
        getVideoList();
      } else {
        //重新发送一次请求
        queryParams.value.type = type;
        getVideoList();
      }
    };
    const cumulativeVideos = ref([]);
    //获取字典数据
    const getSysDicType = async dicType => {
      //获取字典数据
      const res = await SysDictDataControllerService.dictTypeUsingGet(dicType);
      return res;
    };
    const queryParams = ref({
      title: null,
      type: null,
      duration: null,
      descr: null,
      coverUrl: null,
      videoUrl: null,
      status: null
    });
    //获取全部的视频数据
    const getVideoList = async () => {
      //获取视频数据
      const res = await XiaoniuFrontedControllerService.getVideoInfo(queryParams.value);
      if (res.data.code === 200) {
        cumulativeVideos.value = res.data.data;
      }
    };
    onMounted(() => {
      getSysDicType('video_type').then(res => {
        //遍历res.data取出其中的dictLabel放到category数组之中
        // const dictLabels = res.data.map((item: any) => item.dictLabel);
        // categoryNameList.value = ["全部", ...dictLabels];
        categoryNameList.value = [{
          "dictValue": "0",
          "dictLabel": "全部"
        }, ...res.data];
      });
      //获取视频数据
      getVideoList();
    });
    const handleNum = num => {
      return num > 10000 ? (num / 10000).toFixed(1) + "万" : num;
    };
    const handleDate = dateTime => {
      const currentDate = new Date();
      const inputDate = new Date(dateTime);
      // 计算时间差（以毫秒为单位）
      const timeDifference = currentDate - inputDate;
      if (timeDifference < 60 * 60 * 1000) {
        const minutes = Math.floor(timeDifference / 1000 / 60);
        return `${minutes}分钟前`;
      } else if (timeDifference < 24 * 60 * 60 * 1000) {
        const hours = Math.floor(timeDifference / 1000 / 60 / 60);
        return `${hours}小时前`;
      } else {
        const currentYear = currentDate.getFullYear();
        const inputYear = inputDate.getFullYear();
        // 判断是否今年
        if (inputYear < currentYear) {
          const month = inputDate.getMonth() + 1; // 月份是从0开始的
          const day = inputDate.getDate();
          return `${inputYear}-${month}-${day}`;
        } else {
          const month = inputDate.getMonth() + 1; // 月份是从0开始的
          const day = inputDate.getDate();
          return `${month}-${day}`;
        }
      }
    };
    const handleDuration = time => {
      time = parseInt(time);
      time = Math.floor(time);
      let h = Math.floor(time / 3600);
      let m = Math.floor(time % 3600 / 60);
      let s = Math.floor(time % 60);
      // Format with hours if needed
      if (h > 0) {
        h = h < 10 ? '0' + h : h;
        m = m < 10 ? '0' + m : m;
        s = s < 10 ? '0' + s : s;
        return h + ':' + m + ':' + s;
      } else {
        // Keep original format for videos under an hour
        m = m < 10 ? '0' + m : m;
        s = s < 10 ? '0' + s : s;
        return m + ':' + s;
      }
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categoryNameList.value, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["category-btn new-category-btn", {
            'active': item.dictValue === selectedCategory.value
          }]),
          key: index,
          onClick: $event => changeCategory(item.dictValue)
        }, [item.dictValue === '0' ? (_openBlock(), _createElementBlock("span", _hoisted_6, _hoisted_8)) : _createCommentVNode("", true), _createElementVNode("span", null, _toDisplayString(item.dictLabel), 1)], 10, _hoisted_5);
      }), 128))])]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cumulativeVideos.value, item => {
        return _openBlock(), _createElementBlock("div", {
          class: "video-card new-video-card",
          key: item.id
        }, [_hoisted_12, _createElementVNode("a", {
          href: `/video/detail/${item.id}`,
          target: "_blank",
          class: "video-card__link"
        }, [_createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createElementVNode("picture", _hoisted_17, [_createElementVNode("img", {
          src: item.coverUrl,
          alt: item.title
        }, null, 8, _hoisted_18)]), _hoisted_19]), _createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_createElementVNode("span", _hoisted_23, [_hoisted_24, _createElementVNode("span", _hoisted_25, _toDisplayString(handleNum(item.play)), 1)]), _createElementVNode("span", _hoisted_26, [_hoisted_27, _createElementVNode("span", _hoisted_28, _toDisplayString(handleNum(item.danmu)), 1)])]), _createElementVNode("div", _hoisted_29, _toDisplayString(handleDuration(item.duration)), 1)])])]), _createElementVNode("div", _hoisted_30, [_createElementVNode("div", _hoisted_31, [_createElementVNode("h3", _hoisted_32, [_createElementVNode("a", {
          href: `/video/detail/${item.id}`,
          target: "_blank",
          title: item.title
        }, _toDisplayString(item.title), 9, _hoisted_33)])])])])], 8, _hoisted_13)]);
      }), 128))])])])])]);
    };
  }
});